<template>
    <div class="insta-slider-cont">
        <ul id="insta_slider" v-show="!is_loading">
            <li v-for="media in insta_medias"><a :href="media.permalink" target="_blank"><img class="responsive-img" :src="media.media_url"></a></li>
        </ul>
        <div class="row" v-show="is_loading">
            <div class="col s12 center-align">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true" style="font-size: 2.5rem;"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InstagramComponent",
        props: [
            'getInstagramMediasUrl'
        ],
        components: {},
        data() {
            return {
                insta_medias: [],
                is_loading: true
            }
        },
        created () {
        },
        mounted () {
            let me = this;

            axios.get(this.getInstagramMediasUrl)
            .then(function (response) {
                me.insta_medias = response.data.insta_medias;

                me.is_loading = false;

                let insta_slider = $('#insta_slider').lightSlider({

                    item: 5.5,
                    loop: true,
                    slideMove: 1,
                    easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
                    speed: 1200,
                    pause: 5000,
                    pager: false,
                    auto: true,
                    prevHtml: '<i class="material-icons">chevron_left</i>',
                    nextHtml: '<i class="material-icons">chevron_right</i>',
                    slideMargin: 0,
                    responsive : [
                        {
                            breakpoint:600,
                            settings: {
                                item: 2.5,
                                controls: false
                            }
                        },
                    ]
                });
            }).catch(function (error){

            })
        }
    }
</script>

<style scoped>

</style>
